import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../../Util/Session/session.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttendanceEmployeeService {

   constructor(
        private http: HttpClient,
        private session: SessionService,
      ) {
        try {
          environment.API_URL = this.session.GetUserDetails().ApiUrl;
        } catch (e) { }
      }
    
      AttendanceEmployee(ComboDetail: any) {
        return this.http.post<any>(environment.API_URL + `ESS_EmpAttendanceDetails/Report`,
          this.session.SetClass(ComboDetail)
        ).pipe(map(response => {
          if (response.Error_Code == '11' || response.Error_Code == '02') {
            this.session.End();
          } else {
            return response;
          }
        }));
      }
  
}
